import type { AssetDetail } from '~/app/services/asset/asset.service';
import { AssetOcppAuthenticationSection } from './AssetOcppAuthenticationSection';

type Props = {
  asset: AssetDetail;
  organizationChargerAuthEnabled: boolean;
  organizationLoading?: boolean;
};

export function AssetDetailOcppAuthTab(props: Props) {
  return <AssetOcppAuthenticationSection {...props} />;
}
